var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountEmptyTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 155,
    viewBox: "0 0 166 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.217 125.151C120.778 125.151 147.176 98.7531 147.176 66.0755C147.176 33.3979 120.662 7 88.217 7C55.6557 7 29.2578 33.3979 29.2578 66.0755C29.2578 98.7531 55.6557 125.151 88.217 125.151Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.659 47.3581C157.292 47.3581 159.426 45.2234 159.426 42.5902C159.426 39.9569 157.292 37.8223 154.659 37.8223C152.025 37.8223 149.891 39.9569 149.891 42.5902C149.891 45.2234 152.025 47.3581 154.659 47.3581Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.639 28.7525C163.437 28.7525 164.895 27.2947 164.895 25.4964C164.895 23.6981 163.437 22.2402 161.639 22.2402C159.841 22.2402 158.383 23.6981 158.383 25.4964C158.383 27.2947 159.841 28.7525 161.639 28.7525Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9358 27.3502C33.7341 27.3502 35.1919 25.8923 35.1919 24.094C35.1919 22.2957 33.7341 20.8379 31.9358 20.8379C30.1375 20.8379 28.6797 22.2957 28.6797 24.094C28.6797 25.8923 30.1375 27.3502 31.9358 27.3502Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0471 90.1469C15.3868 90.1469 18.0942 87.4396 18.0942 84.0998C18.0942 80.7601 15.3868 78.0527 12.0471 78.0527C8.70738 78.0527 6 80.7601 6 84.0998C6 87.4396 8.70738 90.1469 12.0471 90.1469Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5476_64658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.212 121.858H37.5762C35.6547 121.858 34.0781 120.282 34.0781 118.36V94.2676C34.0781 92.3461 35.6547 90.7695 37.5762 90.7695H136.212C138.134 90.7695 139.711 92.3461 139.711 94.2676V118.36C139.711 120.282 138.134 121.858 136.212 121.858Z",
    fill: "url(#paint0_linear_5476_64658)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.858 102.447H64.9232C63.7408 102.447 62.8047 101.729 62.8047 100.821C62.8047 99.9137 63.7408 99.1953 64.9232 99.1953H119.858C121.04 99.1953 121.977 99.9137 121.977 100.821C121.977 101.729 121.04 102.447 119.858 102.447Z",
    fill: "#D6DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.15 112.349H64.9232C63.7408 112.349 62.8047 111.631 62.8047 110.724C62.8047 109.816 63.7408 109.098 64.9232 109.098H100.15C101.333 109.098 102.269 109.816 102.269 110.724C102.269 111.631 101.333 112.349 100.15 112.349Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6605 115.059C53.5039 115.059 57.4303 111.133 57.4303 106.289C57.4303 101.446 53.5039 97.5195 48.6605 97.5195C43.817 97.5195 39.8906 101.446 39.8906 106.289C39.8906 111.133 43.817 115.059 48.6605 115.059Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1213 104.29L46.6032 109.759L45.1953 108.338L50.7134 102.869L52.1213 104.29Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6032 102.869L52.1213 108.338L50.7134 109.759L45.1953 104.29L46.6032 102.869Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5476_64658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.533 42.5086H40.8965C38.975 42.5086 37.3984 40.932 37.3984 39.0105V14.918C37.3984 12.9965 38.975 11.4199 40.8965 11.4199H139.533C141.454 11.4199 143.031 12.9965 143.031 14.918V39.0105C143.031 40.932 141.454 42.5086 139.533 42.5086Z",
    fill: "url(#paint1_linear_5476_64658)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.178 23.0974H68.2436C67.0611 23.0974 66.125 22.379 66.125 21.4716C66.125 20.5641 67.0611 19.8457 68.2436 19.8457H123.178C124.361 19.8457 125.297 20.5641 125.297 21.4716C125.297 22.379 124.361 23.0974 123.178 23.0974Z",
    fill: "#D6DCE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.471 32.9998H68.2436C67.0611 32.9998 66.125 32.2814 66.125 31.3739C66.125 30.4665 67.0611 29.748 68.2436 29.748H103.471C104.653 29.748 105.589 30.4665 105.589 31.3739C105.589 32.2814 104.653 32.9998 103.471 32.9998Z",
    fill: "#D6DCE8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9808 35.7096C56.8243 35.7096 60.7507 31.7832 60.7507 26.9398C60.7507 22.0963 56.8243 18.1699 51.9808 18.1699C47.1373 18.1699 43.2109 22.0963 43.2109 26.9398C43.2109 31.7832 47.1373 35.7096 51.9808 35.7096Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6914 25.4142L50.4662 31.6394L47 28.1733L48.4142 26.7591L50.4662 28.811L55.2772 24L56.6914 25.4142Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5476_64658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.395 81.9969H25.709C23.7875 81.9969 22.2109 80.4202 22.2109 78.4988V54.4063C22.2109 52.4848 23.7875 50.9082 25.709 50.9082H124.345C126.267 50.9082 127.843 52.4848 127.843 54.4063V78.4988C127.893 80.4695 126.316 81.9969 124.395 81.9969Z",
    fill: "url(#paint2_linear_5476_64658)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8402 75.2467C41.6836 75.2467 45.61 71.3203 45.61 66.4769C45.61 61.6334 41.6836 57.707 36.8402 57.707C31.9967 57.707 28.0703 61.6334 28.0703 66.4769C28.0703 71.3203 31.9967 75.2467 36.8402 75.2467Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6914 64.4259L35.4662 70.6512L32 67.185L33.4142 65.7708L35.4662 67.8227L40.2772 63.0117L41.6914 64.4259Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.038 62.5857H53.1029C51.9205 62.5857 50.9844 61.8673 50.9844 60.9599C50.9844 60.0524 51.9205 59.334 53.1029 59.334H108.038C109.22 59.334 110.156 60.0524 110.156 60.9599C110.156 61.8673 109.171 62.5857 108.038 62.5857Z",
    fill: "#D6DCE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3302 72.5369H53.1029C51.9205 72.5369 50.9844 71.8185 50.9844 70.911C50.9844 70.0036 51.9205 69.2852 53.1029 69.2852H88.3302C89.5126 69.2852 90.4487 70.0036 90.4487 70.911C90.3995 71.8185 89.4634 72.5369 88.3302 72.5369Z",
    fill: "#D6DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5476_64658",
    x: 12.0781,
    y: 79.7695,
    width: 149.633,
    height: 75.0879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5476_64658"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5476_64658",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5476_64658",
    x: 15.3984,
    y: 0.419922,
    width: 149.633,
    height: 75.0879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5476_64658"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5476_64658",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5476_64658",
    x: 0.210938,
    y: 39.9082,
    width: 149.633,
    height: 75.0879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5476_64658"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5476_64658",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5476_64658",
    x1: 86.8599,
    y1: 90.0504,
    x2: 86.8599,
    y2: 122.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5476_64658",
    x1: 90.1802,
    y1: 10.7008,
    x2: 90.1802,
    y2: 42.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5476_64658",
    x1: 74.9933,
    y1: 50.1891,
    x2: 74.9933,
    y2: 82.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountEmptyTransactions);
export default __webpack_public_path__ + "static/media/account-empty-transactions.0ba111dc7fffb91be1823d1d6089a055.svg";
export { ForwardRef as ReactComponent };